import { render, staticRenderFns } from "./collect copy.vue?vue&type=template&id=58a001ca&scoped=true&"
import script from "./collect copy.vue?vue&type=script&lang=js&"
export * from "./collect copy.vue?vue&type=script&lang=js&"
import style0 from "./collect copy.vue?vue&type=style&index=0&id=58a001ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a001ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58a001ca')) {
      api.createRecord('58a001ca', component.options)
    } else {
      api.reload('58a001ca', component.options)
    }
    module.hot.accept("./collect copy.vue?vue&type=template&id=58a001ca&scoped=true&", function () {
      api.rerender('58a001ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataPirate/channelCom/collect copy.vue"
export default component.exports